import { LitElement } from '~/lib/bn-lit-element';
import { css, svg } from '../../utility/lit-entity';
import { DeviceMonitoringChartLayerMixin } from './device-monitoring-chart-layer-mixin';
import { hasWarning as levelWarning, hasAlert as levelAlert } from './device-monitoring-chart-layer-levels';
import { hasAlert as batteryAlert } from './device-monitoring-chart-layer-battery';
import { hasAlert as cellAlert } from './device-monitoring-chart-layer-cell';

const warningChecks = [levelWarning, batteryAlert, cellAlert];
const alertChecks = [levelAlert];

class DeviceMonitoringChartLayerWarningTabs extends DeviceMonitoringChartLayerMixin(LitElement) {
  static get styles() {
    return [...super.styles, css`
      .tab {
        opacity: 0;
        stroke-width: 0;
      }
      .tab.background {
        opacity: 1;
      }
      .tab.hovered {
        opacity: 1;
        transform: scaleY(1.5) translateY(1px);
      }
      .tab.alert { fill: var(--red-20); }
      .tab.alert.hovered { fill: var(--red-30); }
      .tab.warning { fill: var(--yellow-20); }
      .tab.warning.hovered { fill: var(--yellow-20); }
      .tab.alert.selected,
      .tab.warning.selected,
      .tab.background.selected {
        opacity: 1;
        fill: var(--blue-50);
        transform: scaleY(3.1) translateY(5px);
      }
    `];
  }

  renderLayerSVG() {
    const parsedEvents = [...this.events]
      .map((event) => {
        const level = this.levels && this.levels.find((level) => level.rawDate === event.rawDate);
        const warning = warningChecks.map((checkFunction) => checkFunction(event)).includes(true);
        const alert = !level || alertChecks.map((checkFunction) => checkFunction(event)).includes(true);

        return { ...event, warning, alert };
      })
      .sort((a, b) => a.date.diff(b.date));

    return svg`
      <g>${this._renderEvents({ parsedEvents, notificationLevel: 'warning', background: true })}</g>
      <g>${this._renderEvents({ parsedEvents, notificationLevel: 'alert', background: true })}</g>
      <g>${this._renderEvents({ parsedEvents, notificationLevel: 'warning' })}</g>
      <g>${this._renderEvents({ parsedEvents, notificationLevel: 'alert' })}</g>
    `;
  }

  _renderEvents({ parsedEvents, notificationLevel, background }) {
    if (!parsedEvents || parsedEvents.length === 0) {
      return svg``;
    }

    const { TAB_HEIGHT } = this.constants();
    return parsedEvents.map((event) => {
      if (!event[notificationLevel]) {
        return;
      }

      const scaledDate = this.xScale(event.date);
      const highlightX = scaledDate - (this.levelWidthPadded / 2) - this.padding;
      const width = this.levelWidthPadded + this.padding * 2;

      const classList = ['tab'];
      classList.push(notificationLevel);
      if (background) {
        classList.push('background');
      } else {
        classList.push(...this.getSelectableClassList(event));
      }

      return svg`
        <rect
          x="${highlightX}"
          y="${-TAB_HEIGHT + 3}"
          height="${TAB_HEIGHT - 6}"
          width="${width}"
          class="${classList.join(' ')}"
        ></rect>
      `;
    }).filter((ele) => ele);
  }
}

window.customElements.define('device-monitoring-chart-layer-warning-tabs', DeviceMonitoringChartLayerWarningTabs);
